<div class="calendario-pago-pension-home">
<div class="calendario-container">
  <ion-card class="card-calendario ion-no-padding ion-no-margin">
    <ion-card-header class="header-calendario ion-no-margin">
      <ion-card-title class="title-calendario">Calendario de pago de pensión 2024</ion-card-title>
      <ion-card-subtitle class="subtitle-calendario ion-no-margin">
        <p class="ion-no-margin">Este calendario señala la fecha de pago según el primer apellido de la persona afiliada, o causante en caso de Pensión de Vejez y Pensión de Sobrevivencia.</p>
        <p class="ion-no-margin">Válido para todos los medios de pago, incluyendo los realizados por la Caja de Compensación Los Héroes.</p>
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content class="card-content-calendario ion-no-padding">
        <ion-grid class="ion-no-padding">
          <ion-row class="calendario-row-header">
            <ion-col class="header-col primera-columna"><strong>Mes</strong></ion-col>
            <ion-col class="header-col segunda-columna"><strong>Apellidos de A a L</strong></ion-col>
            <ion-col class="header-col"><strong>Apellidos de M a Z</strong></ion-col>
          </ion-row>
          <ion-row *ngFor="let item of calendario" class="calendario-row-data">
            <ion-col class="data-col primera-columna"><strong>{{ item.mes }}</strong></ion-col>
            <ion-col class="data-col segunda-columna">{{ item.apellidoAL }}</ion-col>
            <ion-col class="data-col">{{ item.apellidoMZ }}</ion-col>
          </ion-row>
        </ion-grid>
    </ion-card-content>

    <ion-footer class="footer-calendario ion-no-border">
      <ion-text class="footer-text">
        Para más información, consulta tu Comprobante de Pago de Pensión en <a (click)="irCertificados()">Certificados.</a>
      </ion-text>
      <ion-text class="footer-text">
        También, puedes solicitar que tu pensión sea pagada en tu cuenta bancaria a través del <a (click)="irCambioViaPago()">Cambio de vía de pago.</a>
      </ion-text>
    </ion-footer>
  </ion-card>
</div>
</div>